import React, { useState, useLayoutEffect, useEffect, useContext } from 'react';
import { View, StyleSheet } from 'react-native';
import HeaderButton from '../../../components/Buttons/HeaderButton';
import UserForm from './components/UserForm';
import { OrganizationContext } from '../../../context/OrganizationProvider';
import CustomSnackbar from '../../../components/CustomSnackbar';
import useFetch from '../../../utils/useFetch';

const CreateUserScreen = ({ navigation }) => {
    const { post } = useFetch();
    const { organizationId } = useContext(OrganizationContext);
    const [email, setEmail] = useState();
    const [isAdminSelected, setIsAdminSelected] = useState(false);
    const [isMemberSelected, setIsMemberSelected] = useState(false);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
    const [snackbarVisible, setSnackbarVisible] = useState(false);

    useLayoutEffect(() => {
        navigation.setOptions({
            headerTitle: 'New User',
            headerRight: () => (
                <HeaderButton
                    onPress={onSaveUserPressedHandler}
                    accessibilityLabel="Save new user"
                    accessibilityHint="Press this button to save this new user"
                    buttonText="Save"
                />
            )
        });
    }, [navigation, setSaveButtonDisabled, setSnackbarVisible]);

    useEffect(() => {
        if (email) {
            setSaveButtonDisabled(false);
        } else {
            setSaveButtonDisabled(true);
        }
    }, [email]);

    const onSaveUserPressedHandler = async () => {
        await post(`/api/users`, {
            organizationId: organizationId,
            email: email,
            isAdminForOrganization: isAdminSelected,
            isVoterInOrganization: isMemberSelected
        });

        setSaveButtonDisabled(true);
        setSnackbarVisible(true);
    }

    const onSnackbarDismissedHandler = () => {
        setSnackbarVisible(false);
        navigation.navigate('AdminUsersDashboard');
    }

    return (
        <View style={styles.screen}>
            <View style={styles.contentContainer}>
                <UserForm
                    emailValue={email}
                    onChangeEmailText={email => setEmail(email)}
                    isAdminChecked={isAdminSelected}
                    onAdminPressed={() => setIsAdminSelected(!isAdminSelected)}
                    isMemberChecked={isMemberSelected}
                    onMemberPressed={() => setIsMemberSelected(!isMemberSelected)}
                    formButtonText='Save User'
                    formButtonAccessibilityLabel='Save User'
                    formButtonAccessibilityHint='Press this button to save this new user'
                    formButtonDisabled={saveButtonDisabled}
                    formButtonPressed={onSaveUserPressedHandler}
                />
            </View>
            <CustomSnackbar
                message="New user was saved."
                visible={snackbarVisible}
                onDismiss={onSnackbarDismissedHandler}
                actionLabel='GO BACK'
                actionOnPress={() => navigation.navigate('AdminUsersDashboard')}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    screen: {
        flex: 1,
    },
    contentContainer: {
        paddingVertical: 30,
        paddingHorizontal: 20,
    }
});

export default CreateUserScreen;